<template>
  <div class="team-form">
    <div class="content">
      <!-- {{ form }} -->
      <el-form :inline="true" :model="form" ref="form" :rules="rules" class="forms" size="small" label-width="106px">
        <div class="text">考勤组信息</div>
        <div class="form-row">
          <el-form-item label="考勤组名称" prop="name" style="display: block;">
            <el-input v-model="form.name" placeholder="请输入考勤组名称" maxlength="30" style="width: 550px;" clearable show-word-limit></el-input>
          </el-form-item>
          <el-form-item label="考勤组负责人" prop="managerUserList">
            <el-select v-model="form.managerUserList" @click.native="openUserPicker('add', 'leader')" key="main" value-key="name" class="select-u" placeholder="请选择考勤组负责人" collapse-tags size="medium"
              multiple popper-class="hidden">
              <el-option v-for="(user, index) in form.managerUserList" :label="user.serial + ' ' + user.name" :key="index" :value="user"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="考勤人员" prop="memberUserList">
            <el-select v-model="form.memberUserList" @click.native="openUserPicker('add', 'member')" key="main" value-key="name" class="select-u" :class="form.memberUserList.length>1?'select-more':''" placeholder="请选择考勤人员" collapse-tags size="medium"
              multiple popper-class="hidden">
              <el-option v-for="(user, index) in form.memberUserList" :label="user.serial + ' ' + user.name" :key="index" :value="user"></el-option>
            </el-select>
          </el-form-item>
        </div>
        <div class="text">考勤设置</div>
        <div class="form-row">
          <el-form-item label="考勤班次" prop="shiftIds" style="display: block;">
            <el-select v-model="form.shiftIds" multiple placeholder="请选择考勤班次" style="width: 550px;">
              <el-option v-for="item in shiftListAll" :key="item.id" :label="item.label" :value="item.id">
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="打卡地点" prop="addresss" required>
            <el-input :disabled="true" :value="form.addresss" style="width: 550px;"></el-input>
          </el-form-item>
          <el-form-item label="有效范围" prop="rangeMeters">
            <el-select v-model="form.rangeMeters" placeholder="请选择">
              <el-option v-for="index in 10" :key="index" :label="100 * index + '米'" :value="100 * index">
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label=" " label-width="40px" style="display: block;">
            <el-checkbox v-model="form.repairEnabled">允许补卡</el-checkbox>
          </el-form-item>
          <template v-if="form.repairEnabled">
            <el-form-item label="每月可提交" prop="monthlyRepairQuota" style="width: 300px;">
              <el-input v-model="form.monthlyRepairQuota" maxlength="2" style="width: 50px;" @input="onCheckInput($event, 'monthlyRepairQuota')"></el-input>次补卡
            </el-form-item>
            <el-form-item label="每月" prop="repairResetDay" style="width: 300px;">
              <el-input v-model="form.repairResetDay" maxlength="2" style="width: 50px;" @input="onCheckInput($event, 'repairResetDay')"></el-input>日起重新计算
            </el-form-item>
          </template>
        </div>
      </el-form>
      <div class="footer" :class="[isCollapsed ? 'footer-collapsed' : '']">
        <el-button type="info" plain @click="back">返回</el-button>
        <el-button type="primary" plain @click="reset">重置</el-button>
        <el-button type="primary" @click="save" :loading="btnSave">保存</el-button>
      </div>
    </div>
    <!-- 成员选择 -->
    <org-picker :title="pickerDialog.title" :multiple="true" ref="orgPicker" @ok="selectedUser" />
  </div>
</template>
<script>
import OrgPicker from "@/components/OrgPicker";
export default {
  name: 'attendanceManagementTeamAdd',
  components: { OrgPicker },
  computed: {
    isCollapsed() {
      return this.$store.state.isCollapsed
    }
  },
  data() {
    return {
      form: {
        name: '',
        managerUserList: [],
        managerUserIds: [], // 考勤组负责人
        memberUserList: [],
        memberUserIds: [],
        shiftIds: [], // 考勤班次
        addresss: '广州市白云区广州民营科技园云正大道 1107 号',
        rangeMeters: '', //有效范围
        repairEnabled: '',//允许补卡
        monthlyRepairQuota: '2',//每月可提交补卡次数
        repairResetDay: '1', //每月重新计算

      },
      shiftListAll: [],
      btnSave: false,
      rules: {
        name: [
          { required: true, message: '请输入考勤组名称', trigger: 'change' },
        ],
        managerUserList: [
          { required: true, message: '请选择考勤组负责人', trigger: 'change' }
        ],
        shiftIds: [
          { required: true, message: '请选择考勤班次', trigger: 'change' }
        ],
        monthlyRepairQuota: [
          { required: true, message: '请输入每月可补卡次数', trigger: 'change' },
          {
            validator: (rule, value, callback) => {
              if (value === null || value === undefined || value === '') {
                return callback(new Error('请输入每月可补卡次数'))
              }
              const num = Number(value)
              if (!Number.isInteger(num) || isNaN(num)) {
                return callback(new Error('请输入0-30之间的整数'))
              }
              if (num < 0 || num > 30) {
                return callback(new Error('请输入0-30之间的整数'))
              }
              callback()
            }, trigger: 'change'
          }
        ],
        repairrepairResetDay: [
          { required: true, message: '请输入每月重新计算日', trigger: 'change' },
          {
            validator: (rule, value, callback) => {
              if (value === null || value === undefined || value === '') {
                return callback(new Error('请输入每月重新计算日'))
              }
              const num = Number(value)
              if (!Number.isInteger(num) || isNaN(num)) {
                return callback(new Error('请输入1-31之间的整数'))
              }
              if (num < 1 || num > 31) {
                return callback(new Error('请输入1-31之间的整数'))
              }
              callback()
            }, trigger: 'change'
          }
        ]
      },
      pickerDialog: {
        title: '',
        type: ''
      }
    }
  },
  activated() {
    this.getShiftList()
    let id = this.$route.query.id
    if (id) {
      this.getDetail(id)
    } else {
      this.reset()
    }

  },
  created() {

  },
  methods: {
    // 打开成员选择
    openUserPicker(dialogType, dialogName) {
      this.pickerDialog.type = dialogType
      this.pickerDialog.name = dialogName
      let selectedUsers = []
      if (dialogType === 'add') {

      } else if (dialogType === 'edit') {

      }
      if (dialogName === 'leader') {
        this.pickerDialog.title = '考勤组负责人'
        selectedUsers = this.form.managerUserList
      } else if (dialogName === 'member') {
        this.pickerDialog.title = '考勤人员'
        selectedUsers = this.form.memberUserList
      }

      // if(type ==='main'){
      //     selectedUsers = this.form.mainAccount.usingUserList
      // }else if (type === 'sub') {
      //     this.currentSubIndex = index; // 新增这行
      //     selectedUsers =  this.form.subAccountList[this.currentSubIndex].usingUserList
      // }
      console.log('selectedUsers', selectedUsers);
      this.$refs.orgPicker.show(selectedUsers, 'user');
    },
    //用户选择回调
    selectedUser(data) {
      let dialogName = this.pickerDialog.name
      if (dialogName === 'leader') {
        this.form.managerUserList = data;
        this.form.managerUserIds = data.map(e => e.id)
      } else if (dialogName === 'member') {
        this.form.memberUserList = data;
        this.form.memberUserIds = data.map(e => e.id)
      }


    },
    back() {
      this.$router.go(-1)
    },
    reset() {
      this.$refs.form.resetFields()
      this.form.repairEnabled = false
    },
    onCheckInput(val, formName) {
      const raw = val && val.target && val.target.value !== undefined ? val.target.value : val
      let v = String(raw === undefined || raw === null ? '' : raw).replace(/[^0-9]/g, '')
      if (v === '') {
        this.form[formName] = ''
        return
      }
      let num = parseInt(v, 10)
      if (isNaN(num)) {
        this.form[formName] = ''
        return
      } else {
        this.form[formName] = num
      }
    },
    save() {
      console.log('>>', this.form)

      this.$refs.form.validate((valid) => {
        // return
        if (valid) {
          this.btnSave = true
          let APIURL = ''
          let message = ''
          // 是否编辑
          if (this.form.id) {
            APIURL = 'groupsEdit'
            message = '编辑成功'

          } else {
            APIURL = 'groupsAdd'
            message = '添加成功'
          }
          this.$api[APIURL](this.form).then((res) => {
            if (res.code == 0) {
              this.$message({ message, type: 'success' })
              this.back()
            }
          }).finally(() => {
            this.btnSave = false
          })
        }
      })
    },
    getShiftList() {
      this.$api.shiftsOptions().then((res) => {
        if (res.code == 0) {
          const list = res.data || []
          list.forEach(item => {
            item.label = item.name + '  ' + item.timeRange
          })
          this.shiftListAll = list
        }
      })
    },
    getDetail(id) {
      this.$api.groupDetail(id).then((res) => {
        if (res.code == 0) {
          let detail = res.data
          this.form.name = detail.name
          this.form.id = detail.id
          this.form.shiftIds = detail.shiftIds
          this.form.rangeMeters = detail.rangeMeters
          this.form.repairEnabled = detail.repairEnabled // 补卡
          this.form.monthlyRepairQuota = detail.monthlyRepairQuota
          this.form.repairResetDay = detail.repairResetDay
          // 成员列表
          this.form.managerUserList = detail.managerUserList
          this.form.managerUserIds = detail.managerUserIds
          this.form.memberUserList = detail.memberUserList
          this.form.memberUserIds = detail.memberUserIds

          console.log(this.form)
        }
      })
    },
  },
}
</script>
<style lang="scss" scoped>
.content {
  width: 100%;
  min-height: calc(100vh - 118px);
  margin-top: 16px;
  padding: 0 16px;
  box-sizing: border-box;
  margin-bottom: 35px;
  background-color: #FFFFFF;
  border-radius: 8px;
  display: flex;
  flex-direction: column;
  flex: 1;


}

.data-title {
  width: 100%;
  height: 32px;
  margin-top: 20px;
  position: relative;

  &::before {
    content: "";
    position: absolute;
    left: 0;
    top: 9px;
    width: 2px;
    height: 16px;
    background: #00B498;
    border-radius: 0px 0px 0px 0px;
  }

  .title-name {
    font-family: PingFang SC, PingFang SC;
    font-weight: bold;
    font-size: 18px;
    color: #2F3030;
    margin-left: 6px;
    line-height: 32px;
  }

}

.text {
  font-family: PingFang SC, PingFang SC;
  font-weight: bold;
  font-size: 16px;
  color: #2F3030;
  margin-top: 32px;
  margin-bottom: 30px;
}

.forms {
  flex: 1;

  // /deep/{
  //     .el-form{
  //         display: flex;
  //         flex-wrap: wrap;
  //     }
  //     .el-form-item{
  //         // flex: 1;
  //         display: flex;
  //         flex-wrap: wrap;
  //     }
  //     .el-form-item__label{
  //         white-space: nowrap;
  //         flex-shrink: 0;
  //     }
  // }
  /deep/ .el-textarea {
    .el-textarea__inner {
      padding-left: 8px;
      width: 204px;
      height: 64px;
    }

    .el-input__count {
      line-height: 1;
      bottom: 6px;
    }
  }

  // /deep/ {
  //   .el-select__tags {
  //     flex-wrap: nowrap;
  //   }

  //   .el-tag__close{
  //       display: none;
  //   }
  // }

  p {
    font-family: PingFang SC, PingFang SC;
    font-weight: bold;
    font-size: 16px;
    color: #2F3030;
  }

  .input-con {
    display: flex;

    .input {
      flex: 1;
      width: 164px;
      line-height: 1;

      /deep/.el-input__inner {
        border-right: none;
        border-radius: 4px 0 0 4px;
      }
    }

    .btn-copy {
      width: 40px;
      height: 32px;
      border-radius: 0 4px 4px 0;
      background-color: #00B498;
      display: flex;
      justify-content: center;
      align-items: center;
      font-size: 12px;
      color: #FFF;
      cursor: pointer;
    }

    .btn-copy-dis {
      background-color: #E3E6E5;
      cursor: default;
    }
  }
}


/* 底部按钮 */
.footer {
  height: 84px;
  background: #FFFFFF;
  display: flex;
  justify-content: center;
  align-items: center;
  position: fixed;
  left: 200px;
  right: 0;
  bottom: 0;
  border-top: 1px solid #EDF2F2;
  box-sizing: border-box;
  transition: left 0.3s ease-in-out;
  z-index: 2;

  .el-button {
    min-width: 88px;
    padding: 12px 20px 10px;
  }

  .el-button+.el-button {
    margin-left: 16px;
  }
}

.footer-collapsed {
  left: 80px;
}

.time-picker {
  width: 204px;
}

.no-set-time-range {
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 350px;
  height: 32px;
  border-radius: 4px 4px 4px 4px;
  border: 1px solid #E3E6E5;
  color: #2F3030;
  box-sizing: border-box;
  padding: 3px 71px 3px 10px;

  .i {
    color: #C0C4CC;
  }

  .t {
    color: #C0C4CC;
    font-family: Arial, Helvetica, sans-serif
  }
}

.is-error .no-set-time-range {
  border-color: #F56C6C;
}
/deep/{
  .select-more{
    .el-select__tags{
      flex-wrap: nowrap;
      .el-tag:nth-child(1){
       max-width: 160px
      }
    }
  }
}
</style>